import React, { useState } from 'react';
import './Footer.css';
import SizeGuideModal from './SizeGuideModal';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [showSizeGuide, setShowSizeGuide] = useState(false);

  const quickLinks = [
    { label: 'About Us', path: '/about' },
    { label: 'Contact Us', path: '/contact' },
    { label: 'Shipping Policy', path: '/shipping' },
    { label: 'Returns & Exchanges', path: '/returns' },
    { label: 'Privacy Policy', path: '/privacy' },
    { label: 'Terms of Service', path: '/terms' },
    { label: 'Size Guide', action: () => setShowSizeGuide(true) },
    { label: 'Care Instructions', path: '/care' }
  ];

  const categories = [
    { label: "Men's Clothing", path: '/mens' },
    { label: "Women's Clothing", path: '/womens' },
    { label: 'Kids Collection', path: '/kids' },
    { label: 'Adaptive Wear', path: '/adaptive' },
    { label: 'Sensory Friendly', path: '/sensory' },
    { label: 'New Arrivals', path: '/new' },
    { label: 'Best Sellers', path: '/bestsellers' },
    { label: 'Sale Items', path: '/sale' }
  ];

  const customerService = [
    { label: 'Track Your Order', path: '/track-order' },
    { label: 'FAQs', path: '/faqs' },
    { label: 'NDIS Information', path: '/ndis' },
    { label: 'Custom Orders', path: '/custom' },
    { label: 'Accessibility Features', path: '/accessibility' },
    { label: 'Gift Cards', path: '/gift-cards' },
    { label: 'Store Locator', path: '/stores' },
    { label: 'Wholesale Inquiries', path: '/wholesale' }
  ];

  const socialMedia = [
    { label: 'Instagram', url: 'https://instagram.com', icon: '' },
    { label: 'Facebook', url: 'https://facebook.com', icon: '' },
    { label: 'Twitter', url: 'https://twitter.com', icon: '' },
    { label: 'YouTube', url: 'https://youtube.com', icon: '' },
    { label: 'Pinterest', url: 'https://pinterest.com', icon: '' }
  ];

  const paymentMethods = [
    'Visa', 'Mastercard', 'Amex', 'PayPal', 'Afterpay', 'Apple Pay', 'Google Pay'
  ];

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      alert(`Thank you for subscribing with: ${email}`);
      setEmail('');
    }
  };

  return (
    <footer className="footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          {/* Company Info & Newsletter */}
          <div className="footer-section company-info">
            <div className="footer-logo">The Shapes United</div>
            <p className="company-description">
              Creating inclusive, adaptive clothing for everyone. 
              We design with comfort, style, and accessibility in mind.
            </p>
            
            {/* Newsletter Signup */}
            <div className="newsletter">
              <h3>STAY CONNECTED</h3>
              <p>Subscribe for updates, exclusive offers, and new arrivals</p>
              <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Enter your email address" 
                  className="newsletter-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="newsletter-btn">Subscribe</button>
              </form>
              <p className="newsletter-note">
                By subscribing, you agree to our Privacy Policy and consent to receive updates.
              </p>
            </div>

            {/* Social Media */}
            <div className="social-media-section">
              <h3>FOLLOW US</h3>
              <div className="social-icons">
                {socialMedia.map((social, index) => (
                  <a 
                    key={index}
                    href={social.url}
                    className="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="social-icon-emoji">{social.icon}</span>
                    <span className="social-icon-label">{social.label}</span>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3>QUICK LINKS</h3>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  {link.action ? (
                    <button className="link-button" onClick={link.action}>
                      {link.label}
                    </button>
                  ) : (
                    <a href={link.path}>{link.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div className="footer-section">
            <h3>SHOP</h3>
            <ul className="footer-links">
              {categories.map((category, index) => (
                <li key={index}>
                  <a href={category.path}>{category.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service */}
          <div className="footer-section">
            <h3>CUSTOMER SERVICE</h3>
            <ul className="footer-links">
              {customerService.map((service, index) => (
                <li key={index}>
                  <a href={service.path}>{service.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section contact-info">
            <h3>CONTACT INFO</h3>
            <div className="contact-details">
              <div className="contact-item">

                <span className="contact-text">123 Fashion Street, Sydney NSW 2000, Australia</span>
              </div>
              <div className="contact-item">

                <span className="contact-text">(02) 1234 5678</span>
              </div>
              <div className="contact-item">

                <span className="contact-text">hello@shapesunited.com</span>
              </div>
              <div className="contact-item">

                <span className="contact-text">Mon-Fri: 9am-6pm AEST</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div className="copyright">
            © {currentYear} The Shapes United. All rights reserved.
          </div>
          
          <div className="payment-methods">
            <span className="payment-label">We accept:</span>
            <div className="payment-icons">
              {paymentMethods.map((method, index) => (
                <span key={index} className="payment-icon">{method}</span>
              ))}
            </div>
          </div>
          
          <div className="footer-legal">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/accessibility">Accessibility Statement</a>
            <a href="/sitemap">Sitemap</a>
          </div>
        </div>
      </div>
      {showSizeGuide && <SizeGuideModal onClose={() => setShowSizeGuide(false)} />}
    </footer>
  );
}

export default Footer;
